<form [formGroup]="permForm" fxLayout="row" fxLayoutAlign="space-between center">
    <ng-container formArrayName="permissions">
        <div class="{{ (modelPermGroup.value.permission_type | resourcePermissionPipe)?.class }} w-100"
            *ngFor="let modelPermGroup of permFormArray.controls" [formGroup]="modelPermGroup | cast">

            <app-checkbox-with-custom-user-click
                [isDisabled]="!hasEditPrivilege && (modelPermGroup.value.permission_type === 'edit' || modelPermGroup.value.permission_type === 'publish')"
                [toolTipsMapping]="toolTipsMapping"
                formControlName="permission_value"></app-checkbox-with-custom-user-click>
        </div>
    </ng-container>
</form>
<!-- 
    <div class="d-flex justify-content-between">
        <button class="btn btn-primary">Save</button>
        <button class="btn btn-secondary">Cancel</button>
    </div>
 -->